import module from 'kendu/legacy/module'
import template from './template.html'
import { equals, element } from 'angular'
import './style.scss'
import './option/component'
import './menu/component'
import './menu-filter/component'
import './menu-options/component'

function ComboboxComponent ($attrs, $compile, $document, $element, $filter, $parse, $q, $scope, $timeout) {
  let $ctrl = this
  let filterBy = $filter('filter')
  let groupBy = $filter('groupBy')
  let orderBy = $filter('orderBy')
  let displayBy
  let selectBy
  let trackBy

  $ctrl.$onInit = $onInit
  $ctrl.$onChanges = $onChanges
  $ctrl.$onDestroy = $onDestroy
  $ctrl.clear = clear
  $ctrl.deleteItem = deleteItem
  $ctrl.toggleItem = toggleItem
  $ctrl.toggleItems = toggleItems
  $ctrl.toggleMenu = toggleMenu
  $ctrl.toggleItemsGroup = toggleItemsGroup
  $ctrl.trackByFnc = trackByFnc
  $ctrl.isActive = isActive
  $ctrl.filterOptions = filterOptions
  $ctrl.setView = setView

  $ctrl.model = []
  $ctrl.view = undefined
  $ctrl.element = $element
  $ctrl.isOpen = false
  $ctrl.multiple = 'multiple' in $attrs
  $ctrl.filterNeedle = ''
  $ctrl.filteredOptions = undefined
  $ctrl.groupedOptions = undefined
  $ctrl.disabled = false
  $ctrl.readonly = false
  $ctrl.editable = true
  $ctrl.menuElement = null
  $ctrl.menuElementCompiler = $compile('<combobox-menu options="$ctrl.options" select-multiple="$ctrl.multiple" combobox="$ctrl"></combobox-menu>')
  $ctrl.menuContainer = element($document[0].body)

  $ctrl.element.on('click', onClick)
  $attrs.$set('tabindex', '0')

  $attrs.$observe('required', (required) => {
    $ctrl.required = required
  })

  $attrs.$observe('readonly', (readonly) => {
    // console.log("readonly ? ", readonly);
    $ctrl.readonly = readonly
    updateEditable()
  })

  $attrs.$observe('disabled', (disabled) => {
    // console.log("disabled ? ", disabled);
    $ctrl.disabled = disabled
    $attrs.$set('tabindex', disabled ? undefined : '0')

    updateEditable()
  })

  function updateEditable () {
    $ctrl.editable = !$ctrl.disabled && !$ctrl.readonly
    // console.log("updateEditable", disabled);

    if (!$ctrl.editable && $ctrl.isOpen) toggleMenu(false)
  }

  function $onInit () {
    // console.log("$onInit");
    $ctrl.ngModel['$render'] = render
    $ctrl.ngModel['$isEmpty'] = isEmpty
    // $ctrl.element.on("focus", onFocus);
    // $ctrl.element.on("blur", onBlur);
  }

  function $onChanges (changes) {
    // console.log("$onChanges()", changes)
    if (changes.displayBy) displayBy = $parse($ctrl.displayBy)
    if (changes.selectBy) selectBy = $parse($ctrl.selectBy)
    if (changes.trackBy) trackBy = $parse($ctrl.trackBy)

    // if (changes.options && !changes.options.isFirstChange()) {
    if (changes.options) {
      $ctrl.options = orderBy(changes.options.currentValue, $ctrl.orderBy || '')

      // $ctrl.model = $ctrl.model.filter(function (item) {return $ctrl.options.indexOf(item) >= 0;});

      filterOptions()
      // setModel();
      render()
    }
  }

  function $onDestroy () {
    if ($ctrl.menuElement) {
      $ctrl.menuElement.remove()
      $ctrl.menuElement = null
    }
  }

  function clear () {
    // console.log("clear()");
    if (!$ctrl.editable) return

    $ctrl.model.length = 0

    setModel()
    render()
  }

  function deleteItem (index) {
    if (!$ctrl.editable) return

    $ctrl.toggleItem($ctrl.model[index])
    $ctrl.setView()
  }

  function getModel () {
    // console.log("getModel");
    return [].concat($ctrl.model)
  }

  function filterOptions (needle) {
    // console.log("filterOptions");
    $ctrl.filterNeedle = needle
    $ctrl.filteredOptions = $ctrl.filterNeedle
      ? filterBy($ctrl.options, $ctrl.filterNeedle)
      : $ctrl.options

    $ctrl.groupedOptions = $ctrl.groupBy
      ? groupBy($ctrl.filteredOptions, $ctrl.groupBy)
      : {'': $ctrl.filteredOptions}
  }

  function isActive (item) {
    // console.log("isActive");
    return $ctrl.model.indexOf(item) >= 0
  }

  function isEmpty (value) {
    // console.log("isEmpty", value);
    return value === undefined || value === null || (Array.isArray(value) && value.length === 0)
    // return value === undefined || value.length === 0;
  }

  function render () {
    // console.log("render");
    let model = [].concat($ctrl.ngModel.$modelValue)

    $ctrl.model = Array.isArray($ctrl.options)
      ? $ctrl.options.filter((item) => !isEmpty(model.find((val) => equals(selectBy({$item: item}), val))))
      : []

    setView()
  }

  function setModel () {
    // console.log("setModel()", getModel());
    let model = getModel().map((item) => selectBy({$item: item}))

    $ctrl.ngModel.$setViewValue($ctrl.multiple ? model : model[0])

    onChangeList.forEach((fnc) => (fnc()))
  }

  function setView () {
    // console.log("setView");
    $ctrl.view = getModel().map((item) => displayBy({$item: item}))
  }

  function toggleItem (item) {
    // console.log("toggleItem()", item);
    if (!$ctrl.editable) return

    let model = $ctrl.model

    if (!$ctrl.multiple) model.length = 0

    if (model.indexOf(item) >= 0) {
      model.splice(model.indexOf(item), 1)
    } else {
      model.push(item)
    }

    setModel()
  }

  function toggleItems (selectAll) {
    // console.log("toggleItems()", selectAll);
    if (!$ctrl.editable) return

    // $ctrl.model.length = 0;

    if (selectAll) {
      $ctrl.filteredOptions.forEach((item) => {
        if ($ctrl.model.indexOf(item) < 0) {
          $ctrl.model.push(item)
        }
      })
    } else {
      $ctrl.filteredOptions.forEach((item) => {
        if ($ctrl.model.indexOf(item) >= 0) {
          $ctrl.model.splice($ctrl.model.indexOf(item), 1)
        }
      })
    }
    setModel()
  }

  function toggleItemsGroup (group) {
    // console.log("toggleItemsGroup()", group);
    if (!$ctrl.multiple || !$ctrl.editable) return

    let model = $ctrl.model
    let selectAll = group.some((item) => model.indexOf(item) < 0)

    if (selectAll) {
      group.forEach((item) => {
        if (model.indexOf(item) < 0) model.push(item)
      })
    } else {
      group.forEach((item) => {
        if (model.indexOf(item) >= 0) model.splice(model.indexOf(item), 1)
      })
    }

    setModel()
  }

  function toggleMenu (isOpen) {
    // console.log("toggleMenu", value);
    if (!$ctrl.editable) {
      return $q.reject()
    }

    $ctrl.filterNeedle = ''

    $ctrl.isOpen = isOpen

    return $timeout(() => {
      if (isOpen) {
        if (!$ctrl.menuElement) {
          $ctrl.menuElementCompiler($scope, (clone) => {
            $ctrl.menuElement = clone
          })
        }

        $ctrl.menuContainer.append($ctrl.menuElement)
      } else {
        if ($ctrl.menuElement) {
          $ctrl.menuElement.remove()
          $ctrl.menuElement = null
        }
      }
    })
  }

  function trackByFnc (item) {
    // console.log("trackByFnc");
    return trackBy({$item: item})
  }

  let onChangeList = []
  $ctrl.onChangeValue = onChangeValue

  /*
   function onBlur () {
   // console.log("onBlur");
   $ctrl.element.off('keypress', onKeydown)
   }
   */

  function onChangeValue (fnc, remove) {
    // console.log("onChangeValue");
    if (remove) {
      onChangeList.splice(onChangeList.indexOf(fnc), 1)
    } else {
      onChangeList.push(fnc)
    }
  }

  /*
   function onFocus () {
   // console.log("onFocus");
   $ctrl.element.on('keypress', onKeydown)
   }
   */

  function onClick () {
    // console.log("onClick");
    if ($ctrl.editable && !$ctrl.isOpen) {
      toggleMenu(true)
    }
  }

  /* function onKeydown($event) {
   console.log($event.which);
   if ($event.which == 38)
   onTabPrev();
   if ($event.which == 40)
   onTabNext();
   }

   function onTabPrev() {
   var elements = $ctrl.element.find("combobox-option");
   console.log(elements);
   }

   function onTabNext() {
   var elements = $ctrl.element.find("combobox-option");
   console.log(elements);
   } */

  /*
   function onKeydown ($event) {
   // console.log("keypress");
   if ($ctrl.editable && !$ctrl.isOpen) {
   toggleMenu(true).then(function () {
   $ctrl.filterNeedle = String.fromCharCode($event.charCode || $event.which)

   // if ($event.which == 38) onTabPrev()
   // if ($event.which == 40) onTabNext()
   })
   }
   }
   */
}

module.component('combobox', {
  controller: ComboboxComponent,
  template: template,
  require: {
    ngModel: 'ngModel',
  },
  bindings: {
    options: '<', // Options array
    selectBy: '@', // The item or property to be selected
    trackBy: '@', // track by function
    orderBy: '@', // order by property
    groupBy: '@', // group by property
    displayBy: '@', // display property
    // placeholder: "@"// The placeholder
  },
  transclude: true,
})



// WEBPACK FOOTER //
// ./src/deprecated/directive/combobox/component.js